<template>
  <v-container fill-height fluid pa-0>
    <v-layout>
      <v-flex shrink>
        <admin-panel-drawe/>
      </v-flex>
      <v-flex>
        <v-container fluid>
          <slot />
        </v-container>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import AdminPanelDrawe from "../components/drawers/AdminPanelDrawer.vue";
export default {
  name: 'AdminLayout',
  components: {
    AdminPanelDrawe
  }
}
</script>